import { createApiMethod } from '../../lib/apiController'

/** method list */
export default {
  /**
   * @example
   function_name: makePaymentAction('your_action_name'),    */
  comment:    createApiMethod('/tech-visit/comment/create'),
  toggleStar: createApiMethod('/tech-visit/comment/toggle'),

  enableVisit: createApiMethod('/tech-visit/enable'),
  terminate:   createApiMethod('/tech-visit/terminate'),

  create: createApiMethod('/tech-visit/create'),

  createTechnician: createApiMethod('/tech-visit/technician/create'),
}



// WEBPACK FOOTER //
// ./src/templates/tech_visits/techVisitActions.js